import React from "react";
import { TailSpin } from "react-loader-spinner";
import { THEME_COLOR } from "../../config";

export default function Loader() {
    return (
        <TailSpin
            height="40"
            width="40"
            color={THEME_COLOR}
            ariaLabel="tail-spin-loading"
            radius="1"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
        />
    )
}